import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/commercial-cleaning", label: "Commercial", testid: "nav-commercial-link" },
  { to: "/residential-cleaning", label: "Residential", testid: "nav-residential-link" },
  { to: "/about", label: "About", testid: "nav-about-link" },
  { to: "/service-areas", label: "Service Areas", testid: "nav-areas-link" },
  { to: "/blog", label: "Blog", testid: "nav-blog-link" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-300 ${scrolled || open ? "bg-forest/90 backdrop-blur-xl shadow-lg shadow-black/10" : "bg-transparent"}`}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 sm:h-20 flex items-center justify-between" aria-label="Main navigation">
        <Link to="/" data-testid="nav-logo-link" aria-label="Glow Green home">
          <Logo />
        </Link>
        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors hover:text-leaf ${isActive ? "text-leaf" : "text-white/85"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-quote-button"
            className="ml-2 inline-flex items-center rounded-full bg-leaf px-5 py-2.5 text-sm font-semibold text-forest-deep transition-all hover:bg-mint hover:scale-[1.03]"
          >
            Request a Free Quote
          </Link>
        </div>
        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden bg-forest-deep/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.testid}-mobile`}
              className={({ isActive }) => `text-base font-medium ${isActive ? "text-leaf" : "text-white/90"}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-quote-button-mobile"
            className="mt-2 inline-flex w-fit items-center rounded-full bg-leaf px-6 py-3 text-sm font-semibold text-forest-deep"
          >
            Request a Free Quote
          </Link>
        </div>
      )}
    </header>
  );
};
